<template>
  <div
    v-if="hasBanners"
    class="category-banner-slot"
  >
    <div class="category-banner-slot__inner">
      <category-banner
        v-for="banner in BANNERS"
        :key="banner.id"
        :data="banner"
        :slot-name="slotName"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import CategoryBanner from './category-banner.vue'

export default {
  name: 'category-banners-slot',

  components: { CategoryBanner },

  props: {
    slotName: {
      type: String,
      default: "clothes_category",
    },
  },

  computed: {
    BANNERS() {
      return this.$store.state.banners[this.slotName] || [];
    },
    bannersCounter() {
      return this.BANNERS.length;
    },
    hasBanners() {
      return !!this.bannersCounter;
    },
  },

  methods: {
    ...mapActions('banners', ['getBanners']),
  },

  serverPrefetch() {
    return this.getBanners({
      slots: [this.slotName],
      withCategory: true
    });
  },
}
</script>

<style lang="scss">
.category-banner-slot {
  &__inner {
    display: flex;
    flex-direction: column;

    @include breakpoint("tablet") {
      flex-direction: row;
      flex-wrap: wrap;
      margin-right: -$mobileOffset;
      margin-bottom: -25px;
    }

    @include breakpoint("desktop") {
      margin-right: -25px;
    }

    .category-banner {
      flex: 0 1 auto;
      margin-bottom: $mobileOffset;

      &:last-child {
        margin-bottom: 0;
      }

      @include breakpoint("tablet") {
        flex: 0 1 calc(33.33% - 16px);
        margin-right: $mobileOffset;
        margin-bottom: 25px;

        &:last-child {
          margin-right: 0;
          margin-bottom: auto;
        }
      }

      @include breakpoint("desktop") {
        flex: 0 1 calc(33.33% - 25px);
        margin-right: 25px;
      }
    }
  }
}
</style>
